<template>
<div class="bg">
    <top-nav title="大会信息"></top-nav>
    <div class="main">
        <van-tabs v-model="active" color="#b03230" @click="changeTab">
            <van-tab v-for="index in 4" :key="index" :name="index">
                <template #title>
                    <img src="@/assets/images/cec2022/info_button1.png" v-if="index==1&&active==1"/>
                    <img src="@/assets/images/cec2022/info_button1_inactive.png" v-if="index==1&&active!=1"/>

                    <img src="@/assets/images/cec2022/info_button2.png" v-if="index==2&&active==2"/>
                    <img src="@/assets/images/cec2022/info_button2_inactive.png" v-if="index==2&&active!=2"/>

                    <img src="@/assets/images/cec2022/info_button3.png" v-if="index==3&&active==3"/>
                    <img src="@/assets/images/cec2022/info_button3_inactive.png" v-if="index==3&&active!=3"/>

                    <img src="@/assets/images/cec2022/info_button4.png" v-if="index==4&&active==4"/>
                    <img src="@/assets/images/cec2022/info_button4_inactive.png" v-if="index==4&&active!=4"/>

                </template>
                <div v-if="index==1">
                    <div class="wel-text" id="welcome">
                        <img src="@/assets/images/cec2022/huanyingci.png" style="margin:0 auto;width:70%"/>
                        <div class="cec-info">
                            尊敬的同道、嘉宾，您们好：<br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十四届中国血管论坛（China Endovascular Course，CEC2022）暨 2022 年国家继续教育学习班将于2022年12月1日-12月4日在上海隆重召开。在此，我们诚挚邀请您参加此次学术盛会。
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CEC2022由复旦大学附属中山医院、首都医科大学附属北京安贞医院、解放军总医院第一医学中心、海峡两岸医药卫生交流协会血管外科分会、中国研究型医院学会血管医学专业委员会、北京博瑞血管健康公益基金会共同主办，复旦大学附属中山医院承办。并得到中国医师协会血管外科医师分会、中国医疗器械行业协会血管器械分会、上海市医师协会血管外科医师分会、上海市医学会血管外科专科分会、北京医学会血管外科学分会、《中华血管外科杂志》、《中华外科杂志》、《中华医学杂志》、《中华普通外科杂志》、《中国实用外科杂志》、《血管及腔内血管外科杂志》，《中国血管外科杂志》（电子版）等多家学术机构和组织的大力支持。
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CEC一直以来是全国乃至全球血管病专业医生学术交流的殿堂，是血管外科医生汲取最前沿学术信息的平台。它引领着中国血管外科的方向与发展，它不忘初心，始终秉承“强化基础诊疗、规范临床操作、服务一线医生、跟踪重大研究、全面展现国内外血管疾病诊疗领域最新进展”不断进步与创新。过去CEC与中国血管病学同成长，将来CEC与中国血管病学共发展。它已经是影响两岸三地乃至世界的中国血管病学术盛会！
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CEC2022欢迎您！上海欢迎您！突如其来的新冠疫情将世界改变了许多，但是改变不了中国血管人的学术进步，改变不了血管人的创新精神，改变不了血管人的交流热情。CEC2022仍将以专家主题演讲，手术演示视频及卫星手术直播等特色形式全面展现国内外血管病领域的技术规范与学术进展；并将携手海峡两岸重要血管外科学术组织，并肩国际顶级血管病学术团体，为中国血管病领域的工作者打造一个“最具国际影响力”的血管外科学术盛宴。
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CEC属于所有为血管疾病而努力奋斗的临床医务人员，属于致力于推动技术革新的科研工作者，更属于受益于日新月异医疗技术的血管病患者。
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们期待您的支持和参与！共享学术盛宴！共促血管健康！
                            <br />
                            <span style="float: right;">CEC2022执行主席：符伟国</span>
                            <br />
                        </div>
                    </div>
                    <div class="cec-info">
                        <img src="@/assets/images/cec2022/info_title1.png" />
                        <div class="text">
                            <video 
                            src="//cdn.edstatic.com/203012120000/6a6749ad16229044d9b3632d6dea1861/2022/10/d3d88801-50ee-4791-a3ba-87d11b00af34.mp4" 
                            x5-video-player-type='h5-page' webkit-playsinline="true" playsinline="true"
                            poster="@/assets/images/cec2022/fuweiguo_top.png"
                            preload="auto"
                            id="play1"
                            @play="videoPlay(1)"
                            controls></video>
                            <!-- <img src="@/assets/images/cec2022/fuweiguo_top.png" /> -->
                            <div class="speaker-words">
                                <img src="@/assets/images/cec2022/icon1.png" class="bottom-icon"/>
                                <div class="text-flex">
                                    <img src="@/assets/images/cec2022/fuweiguo.png" class="left"/>
                                    <span>“2020年以来，因为新冠疫情，实体会议受到影响，但我们的学术交流热情不减，持续的线上学术交流反而使得医学技术和知识的传播更加迅捷。CEC2022我们期待为大家提供一个线下相聚的机会，彼此能够高效、直接、多角度的畅谈与交流。”</span>
                                <br />
                                </div>
                                <div>
                                    <span style="font-weight:500;">新媒体全程助力</span><br />
                                    依托公众号、视频号、微官网等移动端应用来助力大会的高效举办。<br />
                                    沉浸式手术体验<br />
                                    今年将引入最新的技术手段，让手术录播直播的数量和质量，以及器材展示，都得到极大提升！<br />
                                    <span style="font-weight:500;margin-top:20px;">CEC青年发展计划</span><br />
                                    关注青年医生成长，为你们打造成长的平台，一直是CEC的核心目标之一。今年我们新增CEC青年发展计划，为青年医生提供与主流专家同台交流的机会。<br />
                                    CEC2022，值得期待！今年的12月，我们将为中国血管外科再次打造一个极具影响力的学术盛宴，一起领略国际国内顶尖血管专家的手术风采，中坚学者的智慧碰撞，青年才俊的精彩表现！”<br />
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/images/cec2022/info_title2.png" />
                        <div class="text">
                            <video src="//cdn.edstatic.com/203012120000/5791065026cf5d3e4a99f6c9df098e33/2022/10/41506173-e03c-49d5-a5d5-0f07a160f279.mp4" 
                            x5-video-player-type='h5-page' webkit-playsinline="true" playsinline="true"
                            preload="auto"
                            poster="@/assets/images/cec2022/chenzhong_top.png"
                            id="play2"
                            @play="videoPlay(2)"
                            controls></video>
                            <!-- <img src="@/assets/images/cec2022/chenzhong_top.png" /> -->
                            <div class="speaker-words">
                                <img src="@/assets/images/cec2022/icon1.png" class="bottom-icon"/>
                                <div class="text-flex">
                                    <img src="@/assets/images/cec2022/chenzhong.png" class="left"/>
                                    <span><span style="font-weight:500;">“打造系列学术品牌</span><br />
                                    我们不仅有每年的学术会议，更重要的是我们每次学术会议以后的这一年之间，我们把各家医院的系列性的学习班已经办成了一个品牌。我们已经从单纯的医院间的合作，发展到了和厂家公司的合作，甚至发展到与国外著名学术会议的合作，如VEITH会议、LINC会议、CHARING CROSS会议等等。</span>
                                    <br />
                                </div>
                                <div>
                                    <span style="font-weight:500;">吸引更多临床医生关注</span><br />
                                    CEC中国血管论坛不仅包括有我们血管外科医生，也包括了很多介入放射科医生、心内科医生、心外科医生、肾内科医生、内分泌科医生等等，一系列的关注血管疾病相关的医务人员都给予了极大的关注和支持。<br />
                                    未来，CEC也将是帮助和促进青年医师规范化培训、准入的学术平台，提供更好的展示空间与舞台。<br />
                                    当然所有CEC取得的成就离不开所有人员对我们大会的支持，特别是一路走来和我们陪伴的血管外科界的同道，以及支持我们的厂家，各个传播媒体，以及所有前台幕后支持CEC会议的所有的人员。<br />
                                    在这里我也期望我们未来的合作更加的紧密，让CEC有继续发扬光大的空间——不仅能够在中国吸引更多血管疾病同道的关注，也能够在未来与更多的国际组织、国际会议交流协作。<br />
                                    让我们共同携手为中国血管外科的事业做出更多更大的贡献，谢谢！”<br />
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/images/cec2022/info_title3.png" />
                        <div class="text">
                            <video src="//cdn.edstatic.com/203012120000/c6bcf1f13fa60892e47b9915610e9249/2022/10/50a48845-b345-4dca-be25-fefd25379744.mp4" 
                            x5-video-player-type='h5-page' webkit-playsinline="true" playsinline="true"
                            preload="auto"
                            poster="@/assets/images/cec2022/guowei_top.png"
                            id="play3"
                            @play="videoPlay(3)"
                            controls></video>
                            <!-- <img src="@/assets/images/cec2022/guowei_top.png" /> -->
                            <div class="speaker-words">
                                <img src="@/assets/images/cec2022/icon1.png" class="bottom-icon"/>
                                <div class="text-flex">
                                    <img src="@/assets/images/cec2022/guowei.png" class="left"/>
                                    <span>“新一届CEC又将开启了，在此特别欢迎大家踊跃参与 CEC2022年度盛会！<br />
                                    作为我国最大的血管外科继续教育项目，CEC因其新颖的会议形式，广泛的内容覆盖，贴近临床实战背景，以极强的生命力见证和推动了中国血管外科的飞速发展，让CEC成为初级医生学习的课堂，中级医生成长的阶梯，著名专家演讲的舞台，国际信息沟通的渠道和循证医学研究的起点，这是CEC最初的愿景。历经14年的发展，所有这些目标都达到了，但这并不是CEC的终点，而恰恰是CEC新的起点。
                                    </span>
                                    <br />
                                </div>
                                <div>
                                    <span style="font-weight:500;">深化国际合作 助力行业发展</span><br />
                                    作为知识传播的重要平台，CEC历来重视学科建设的国际化视野，早在2011年，CEC便与VIVA和ISES合作，共同举办VIVA meet CEC、ISES meet CEC专场。之后，CEC相继开展与美国VEITH大会，美国NCVH大会、美国SVS大会、英国CHARING CROSS大会和德国LINC大会等当今国际主要的血管大会合作，这些无疑是中外血管同道们进行学术交流的重要管道，极大促进了中外学国专家之间的了解和专业资讯的广泛传播。
                                    <br />
                                    专业化、国际化将成CEC未来发展的不二选择，愿CEC继续为我国血管外科人才培养提供平台，为行业发展提供助力；愿中国血管外科事业尽快走向世界领先水平！”
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="index==2">
                    <organizor></organizor>
                </div>
                <div v-if="index==3">  
                    <column-details></column-details>
                </div>
                <div v-if="index==4" class="cec-info" style="min-height: 500px;">
                    <img src="@/assets/images/cec2022/info_big_title.png" style="margin-bottom: 30px;" />
                    <div class="text">
                        <p>第十四届中国血管论坛（China Endovascular Course，CEC2022）暨2022年国家继续教育学习班将于2022年12月1日-12月4日在线上召开！</p>
                        <p>在此，我们诚挚邀请您参加此次学术盛会。</p>
                    </div>
                    <img src="@/assets/images/cec2022/info_title4.png" />
                    <div class="text">
                        <img src="@/assets/images/cec2022/time.png" style="margin-top: 15px;"/>
                    </div>
                    <img src="@/assets/images/cec2022/info_title5.png" />
                    <div class="text">
                        <p>本届会议使用的线上平台为：<span class="red-text">ZOOM</span></p>
                        <p style="word-break:break-all;">下载链接https://zoom.us/download#client_4meeting</p>
                        <p>您可提前进行下载与安装，非常推荐您使用电脑进行会议的上线，谢谢您。</p>

                    </div>
                    <img src="@/assets/images/cec2022/info_title6.png" />
                    <div class="text">
                       <p>1. 进入会议微官网，点击右下角<span class="red-text">“我的任务”</span>进入到在线任务界面</p>
                       <p>2. 输入您<span class="red-text">手机号码及验证码</span>，即可在线进行任务查询；可点击<span class="red-text">红色箭头</span>的下拉菜单键可展示所在章节的详细日程内容，</p>
                       <p>也可点击右上角的<span class="red-text">“获取PDF”</span>按键获取您PDF版本的任务清单；大会会务组会会前已为您呈送会议任务清单。</p>
                       <div class="flex" style="justify-content: center;">
                            <img src="@/assets/images/cec2022/task_example.png" style="width:45%"/>
                            <img src="@/assets/images/cec2022/task_example.png" style="width:45%"/>
                       </div>
                    </div>
                    <img src="@/assets/images/cec2022/info_title7.png" />
                    <div class="text">
                        <p>本次会议您可以同过以下三个渠道进行关注</p>
                        <p class="red-text font14">1.CEC官方 公众号</p>
                            <img src="@/assets/images/cec2022/gong.png" style="width:60%;margin: 0 auto;"/>
                        <p class="red-text font14">2.CEC官方 微网站</p>
                            <img src="@/assets/images/cec2022/wei.png" style="width:60%;margin: 0 auto;"/>
                        <p class="red-text font14">3.CEC官方 APP</p>
                        <p>· <span class="red-text">苹果手机</span>可从<span class="red-text">应用市场</span>直接下载</p>
                        <p>· <span class="red-text">安卓手机</span>扫码下载</p>
                        <img src="@/assets/images/cec2022/app_qrcode.jpeg" style="width:60%;margin: 0 auto;"/>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
	<img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/>
</div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import organizor from "./organizor.vue" 
import columnDetails from "./component/columnDetails.vue" 
import {ButtonDetail} from '../../config/interface.js'
export default {
    components:{
        topNav,
        organizor,
        columnDetails
    },
    data(){
        return{
            play_id:0,
            active:localStorage.getItem('cec_info')?Number(localStorage.getItem('cec_info')):1,
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
     methods:{
            //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
            videoPlay(index){
                if(this.play_id!=0){
                    
                    document.getElementById('play'+this.play_id).pause();
                    console.log(document.getElementById('play'+index))
                }   
                console.log(index)        
                this.play_id=index;
            },
            changeTab(name){
                this.active=name;
                localStorage.setItem('cec_info',name);
            }

    }
}
</script>

<style scoped lang="scss">
/deep/
.van-tabs{
    padding-top: 5px;
    .van-tabs__wrap{
        margin-bottom: 5px;
    }
    .van-tab__text--ellipsis{
        padding: 5px;
    }
    .van-tabs__line{
        background-color: transparent !important;
    }
}
.bg{
    background: white;

    .main{
        margin-top:48px;
        img{
            display: block;
            width: 100%;
        }
    }
    .cec-info{
        padding: 30px 25px;
        position: relative;
    }
    .cec-info img{
        width: 100%;
    }
    .cec-info .absolute-img{
        position: absolute;
        top:30px;
        left: 0;
    }
    .cec-info .red-text{
        color: #B2312E;
    }
    .cec-info .font14{
       font-size: 14px;
    }
    .cec-info .text{
        margin: 10px 0 30px;
        font-size: 13px;
        line-height: 26px;
    }
    .cec-info video{
        width: 100%;
        border-radius: 10px;
    }
    .cec-info .line1{
        line-height: 40px;
    }
    .cec-info .line1 img{
        width: 20px;
        vertical-align: middle;
        line-height: 40px;
        margin-right: 10px;
    }
    .cec-info  .buttons{
        margin: 140px 0;
    }
    .buttons .flex{
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
    }
    .buttons .flex img{
        width: 33%;
    }
    .wel-text{
        color: white;
        line-height: 20px;
        font-size: 11px;
        padding-top: 2.2rem;
        padding-bottom: 60px;
        background-image:url('../../assets/images/cec2022/wel_bg.png') ;
        background-size: 100% 100%;
    }
    .speaker-words{
        position: relative;
        font-size: 13px;
    }
    .speaker-words .bottom-icon{
        position: absolute;
        right: 0;
        width: 40px;
    }
    .text-flex{
        margin: 30px 0 20px;
    }
    .text-flex img{
        width: 29%;
        float: left;
        margin-right: 10px;
    }
    .bottom-img{
        width: 100%;
        display: block;
    }
}
// .cec-info{
// 	padding: 30px 25px;
// 	position: relative;
// }
// .cec-info img{
// 	width: 100%;
// }
// .cec-info .absolute-img{
// 	position: absolute;
// 	top:30px;
// 	left: 0;
// }
// .cec-info .red-text{
// 	color: #B2312E;
// }
// .cec-info .text{
// 	margin: 10px 0 30px;
// 	font-size: 13px;
// 	line-height: 26px;
// }
// .cec-info video{
//     width: 100%;
//     border-radius: 10px;
// }
// .cec-info .line1{
// 	line-height: 40px;
// }
// .cec-info .line1 img{
// 	width: 20px;
// 	vertical-align: middle;
// 	line-height: 40px;
// 	margin-right: 10px;
// }
// .cec-info  .buttons{
// 	margin: 140px 0;
// }
// .buttons .flex{
// 	width: 100%;
// 	display: flex;
// 	justify-content: space-around;
// 	margin: 20px 0;
// }
// .buttons .flex img{
// 	width: 33%;
// }
// .wel-text{
// 	color: white;
// 	line-height: 20px;
//     font-size: 11px;
//     padding-top: 120px;
//     padding-bottom: 60px;
//     background-image:url('../../assets/images/cec2022/wel_bg.png') ;
//     background-size: 100% 100%;
// }
// .speaker-words{
// 	position: relative;
// 	font-size: 13px;
// }
// .speaker-words .bottom-icon{
// 	position: absolute;
// 	right: 0;
// 	width: 40px;
// }
// .text-flex{
// 	margin: 30px 0 20px;
// }
// .text-flex img{
// 	width: 29%;
// 	float: left;
// 	margin-right: 10px;
// }
// .bottom-img{
//     width: 100%;
//     display: block;
// }

</style>


// WEBPACK FOOTER //
// src/pages/cec2022/info.vue